<template>
    <b-container>
        <h3 class="my-4">Agregar Producto</h3>

        <b-row align-h="center">
            <b-col cols="6">
                <form @submit.prevent="crearProducto(producto)">
                    <b-row class="my-1">
                        <b-col sm="3">
                            <label for="input-default">Nombre:</label>
                        </b-col>
                        <b-col sm="9">
                            <b-input-group size="sm">
                                <template v-slot:append v-if="!$v.producto.NOM_PRODUCTO.required">
                                    <b-input-group-text><strong class="text-danger">*</strong></b-input-group-text>
                                </template>
                                <b-form-input type="text" size="sm" :class="{'is-invalid': $v.producto.NOM_PRODUCTO.$error}"
                                        v-model="$v.producto.NOM_PRODUCTO.$model"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col sm="9" offset-sm="3">
                            <p class="text-danger text-validacion" v-if="!$v.producto.NOM_PRODUCTO.minLength">
                                El nombre debe tener mínimo 4 carácteres
                            </p>
                        </b-col>
                    </b-row>

                    <b-row class="my-1">
                        <b-col sm="3">
                            <label for="input-default">Precio:</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input type="number" size="sm" step="any" 
                                v-model="$v.producto.IMP_UNITARIO.$model"></b-form-input>
                        </b-col>
                    </b-row>
                    <div>
                        <b-form-checkbox v-model="producto.IND_ACTIVO" name="check-button" switch>
                            Disponible para vender
                        </b-form-checkbox>
                    </div>
                    <b-button type="submit" variant="success" class="mt-3" size="sm"
                        :disabled="$v.$invalid || carga">Crear</b-button>
                </form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapActions, masState, mapState } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'Crear',
    data() {
        return {
            producto: {
                NOM_PRODUCTO: '',
                IMP_UNITARIO: '',
                FEC_REGISTRO: '',
                IND_ACTIVO: true
            },
        }
    },
    methods: {
        ...mapActions(['crearProducto'])
    },
    computed: {
        ...mapState(['carga'])
    },
    created() {
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;

        this.producto.FEC_REGISTRO = dateTime;
    },
    validations: {
        producto: {
            NOM_PRODUCTO: {
                required,
                minLength: minLength(4)
            },
            IMP_UNITARIO: {
                required
            }
        }
    }
}
</script>

<style scoped>
    p.text-validacion {
        font-size: 0.8rem;
        text-align: left;
        margin: 0;
    }
    .input-group-text {
        background: #FFF !important;
        border-left: none !important;
    }
</style>>
